import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
    standalone: false
})
export class ToastComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() duration = 4000; // milisegundos
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';

  visible = false;
  toastClass = '';
  iconBg = '';
  private timeout: any;

  showToast(type: 'success' | 'error' | 'warning' | 'info', title: string, message: string, duration = 400000) {
    this.type = type;
    this.title = title;
    this.message = message;
    this.duration = duration;
    this.setStyle();
    this.visible = true;

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => (this.visible = false), this.duration);
  }

  closeToast() {
    this.visible = false;
    clearTimeout(this.timeout);
  }

  private setStyle() {
    switch (this.type) {
      case 'error':
        this.toastClass = 'toast-error';
        this.iconBg = 'rgba(107,11,23,0.08)';
        break;
      case 'success':
        this.toastClass = 'toast-success';
        this.iconBg = 'rgba(21,87,36,0.08)';
        break;
      case 'warning':
        this.toastClass = 'toast-warning';
        this.iconBg = 'rgba(133,100,4,0.08)';
        break;
      case 'info':
        this.toastClass = 'toast-info';
        this.iconBg = 'rgba(12,84,96,0.08)';
        break;
    }
  }
}
